import { Component, AfterViewInit } from '@angular/core';
import { GlobalService } from '@shared/services';
import { ActivatedRoute } from '@angular/router';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements AfterViewInit {

  constructor(private gs: GlobalService, private route: ActivatedRoute) { }

  ngOnInit(): void{
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.refresh(true);
  }
  
  ngAfterViewInit(): void {
    console.log(this.route);
    this.gs.scrollIntoView(this.route);
  }

}
